export default __webpack_public_path__ + "568be4870a2e87ab190fbef9de255b66.jpg";